import { Stack as BaseStack } from '@mui/material';

export default function Stack(props) {
  return <BaseStack {...props} />;
}
